export default __webpack_public_path__ + "static/csv/HomeTiles.9a7e1e43.csv";